import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { FaFlag } from 'react-icons/fa6';

const NeedsAdditionalInfoModal = ({
    modalOpen,
    setModalOpen,
    flaggedComments,
    handleNeedsAdditionalInfoSubmit,
}: {
    modalOpen: boolean;
    setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    flaggedComments: string[];
    handleNeedsAdditionalInfoSubmit: (comment: string) => Promise<void>;
}) => {
    const { register, handleSubmit, formState } = useForm({
        defaultValues: {
            comment: '',
        },
    });

    const { isSubmitting } = formState;

    const onSubmit = async (data: any) => {
        await handleNeedsAdditionalInfoSubmit(data.comment);
        setModalOpen(false);
    };

    return (
        <>
            {modalOpen && (
                <div
                    className='fixed inset-0 z-[99999] flex items-center justify-center bg-black bg-opacity-75'
                    onClick={() => setModalOpen(false)}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        className='relative w-full max-w-xl rounded-lg bg-white shadow-lg'
                    >
                        <div className='p-7'>
                            <h2 className='mb-4 text-3xl font-semibold'>
                                Send Client a Message
                            </h2>

                            <p>
                                You are changing the status of this Fund Request
                                to Needs Additional Info. Please provide some
                                information for the Client in order to help them
                                make the necessary changes.
                            </p>
                            <div className='mt-2 py-4'>
                                <h3 className='mb-2 text-lg font-bold text-black'>
                                    FLAGGED ISSUES
                                </h3>
                                <ul className='space-y-2'>
                                    {flaggedComments.map(
                                        (flaggedComment, index) => (
                                            <li
                                                key={index}
                                                className='flex items-start space-x-2 font-medium text-[#F02D3A]'
                                            >
                                                <FaFlag className='mt-1' />
                                                <span>{flaggedComment}</span>
                                            </li>
                                        )
                                    )}
                                </ul>
                            </div>
                            <div className='mt-6'>
                                <label className='block font-bold'>
                                    Message <span className='text-red'>*</span>
                                </label>
                                <textarea
                                    className='w-full resize-none rounded border p-2'
                                    placeholder='Text'
                                    rows={6}
                                    {...register('comment')}
                                />
                            </div>
                            <div className='flex gap-[16px]'>
                                <button
                                    onClick={() => setModalOpen(false)}
                                    type='button'
                                    className='mt-[30px]  rounded-full border-[2px] px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase transition-colors duration-500 hover:border-[#E6F7F8] hover:bg-[#E6F7F8]'
                                >
                                    Cancel
                                </button>
                                <button
                                    type='button'
                                    className={`mt-[30px] w-40 rounded-full border-[2px] border-[#FEBF3E] bg-[#FEBF3E] px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase  transition-colors duration-500 ${
                                        isSubmitting
                                            ? 'cursor-not-allowed opacity-50'
                                            : 'hover:border-[#E6F7F8] hover:bg-[#E6F7F8]'
                                    }`}
                                    onClick={handleSubmit(onSubmit)}
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? 'Saving...' : 'Save & Send'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default NeedsAdditionalInfoModal;
